import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import Closure from '../../entities/booking/closure';
import Util from '../../../lib/util';

interface ClosureState extends ListState<Closure>{
    editClosure:Closure
}
class ClosureMutations extends ListMutations<Closure>{

}
class ClosureModule extends ListModule<ClosureState,any,Closure>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Closure>(),
        loading:false,
        editClosure:new Closure()
    }
    actions={
        async getAll(context:ActionContext<ClosureState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Closure/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Closure>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<ClosureState,any>,payload:any){
            await Ajax.post('/api/services/app/Closure/Create',payload.data);
        },
        async update(context:ActionContext<ClosureState,any>,payload:any){
            await Ajax.put('/api/services/app/Closure/Update',payload.data);
        },
        async delete(context:ActionContext<ClosureState,any>,payload:any){
            await Ajax.delete('/api/services/app/Closure/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<ClosureState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Closure/Get?Id='+payload.id);
            return reponse.data.result as Closure;
        }
    };
    mutations={
        setCurrentPage(state:ClosureState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:ClosureState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:ClosureState,closure:Closure){
            state.editClosure=closure;
        }
    }
}
const closureModule=new ClosureModule();
export default closureModule;